import { useCurrentSubscriptionApi } from '@aibees/shared/features/price-and-plan/api/use-current-subscription-api';
import { usePaymentStatus } from '@aibees/shared/hooks/payment/use-payment-status';
import { classnames } from '@aibees/shared/utils';
import { Alert, Stack } from '@mui/material';
import { memo } from 'react';
import { AccountPopoverCreditItem } from '../account-popover-credit-item';
import { AccountPopoverCreditPlanDetail } from '../account-popover-credit-plan-detail';
import * as Styled from './styles';
import * as SX from './sx';
import { type AccountPopoverCreditsProps as Props, CreditType } from './types';

export const AccountPopoverCredits = memo(({ className, toRoute }: Props) => {
  const { data } = useCurrentSubscriptionApi();
  const { paymentFailed } = usePaymentStatus();

  return (
    <Styled.Wrapper
      className={classnames('AccountPopoverCredits', className)}
      sx={SX.root}
    >
      <Stack sx={SX.stack}>
        {data && (
          <AccountPopoverCreditItem
            type={CreditType.CREDIT}
            subscription={data}
          />
        )}
        <AccountPopoverCreditPlanDetail toRoute={toRoute} />
        {paymentFailed && (
          <Alert icon={false} severity="error" sx={{ textAlign: 'center' }}>
            Pending on Payment
          </Alert>
        )}
      </Stack>
    </Styled.Wrapper>
  );
});

AccountPopoverCredits.displayName = 'AccountPopoverCredits';
